import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "pantelflora.cookie-consent.v1";

const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setOpen(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-cookie-banner", handler);
    return () => window.removeEventListener("open-cookie-banner", handler);
  }, []);

  const accept = () => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice: "accept", at: new Date().toISOString() })
    );
    setOpen(false);
  };

  const reject = () => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice: "essential-only", at: new Date().toISOString() })
    );
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed inset-x-3 bottom-3 md:inset-x-auto md:left-6 md:bottom-6 md:max-w-sm z-[60]"
        >
          <div className="relative bg-cream text-lava border border-lava/15 p-4 shadow-[0_8px_24px_rgba(28,27,26,0.12)]">
            <button
              type="button"
              onClick={reject}
              data-testid="cookie-banner-close"
              aria-label="Chiudi"
              className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center text-lava/50 hover:text-lava transition-colors"
            >
              <X className="w-3.5 h-3.5" />
            </button>
            <div className="flex items-start gap-3 pr-6">
              <span className="w-8 h-8 bg-olive/10 text-olive flex items-center justify-center mt-0.5 shrink-0">
                <Cookie className="w-3.5 h-3.5" />
              </span>
              <div>
                <p className="font-display text-sm leading-snug tracking-tight font-medium text-lava">
                  Solo cookie tecnici essenziali.
                </p>
                <p className="text-xs text-lava/65 leading-relaxed mt-1 font-light">
                  Nessuna profilazione né tracciamento.{" "}
                  <Link
                    to="/cookie-policy"
                    onClick={() => setOpen(false)}
                    className="underline underline-offset-2 hover:text-olive"
                  >
                    Dettagli
                  </Link>
                  .
                </p>
              </div>
            </div>

            <div className="mt-4 flex gap-2">
              <button
                type="button"
                onClick={reject}
                data-testid="cookie-banner-reject"
                className="flex-1 border border-lava/20 text-lava px-3 py-2 text-xs tracking-tight font-medium hover:bg-lava/5 transition-colors"
              >
                Solo essenziali
              </button>
              <button
                type="button"
                onClick={accept}
                data-testid="cookie-banner-accept"
                className="flex-1 bg-olive hover:bg-olive-deep text-cream px-3 py-2 text-xs tracking-tight font-medium transition-colors"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
